(function(){
  function updateCartAttributes(attrs) {
    const formBody = Object.entries(attrs)
      .map(([k,v]) => encodeURIComponent(`attributes[${k}]`) + '=' + encodeURIComponent(v))
      .join('&');

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formBody
    });
  }

  function attachConsentValidation(root) {
    const tos = root.querySelector('#consent_tos');
    const withdrawal = root.querySelector('#consent_withdrawal');
    const errorEl = root.querySelector('#cart-consent-error');
    if (!tos || !withdrawal) return;

    function showError(show) {
      if (errorEl) {
        errorEl.style.display = show ? 'block' : 'none';
      }
    }

    // Checkout Buttons im Drawer + Cart
    const checkoutButtons = root.closest('body').querySelectorAll(
      'button[name="checkout"], [data-checkout-button], a[href*="/checkout"]'
    );

    checkoutButtons.forEach(btn => {
      btn.addEventListener('click', function(e){
        if (!tos.checked || !withdrawal.checked) {
          e.preventDefault();
          showError(true);
          (tos.checked ? withdrawal : tos).focus();
          return;
        }
        // speichern & dann weiter
        e.preventDefault();
        btn.disabled = true;
        updateCartAttributes({
          consent_tos: tos.checked ? 'Ja' : 'Nein',
          consent_withdrawal: withdrawal.checked ? 'Ja' : 'Nein'
        }).finally(() => {
          if (btn.tagName === 'A' && btn.href) {
            window.location = btn.href;
          } else {
            const form = btn.closest('form');
            if (form) form.submit();
            else window.location = '/checkout';
          }
        });
      });
    });

    tos.addEventListener('change', () => showError(false));
    withdrawal.addEventListener('change', () => showError(false));
  }

  function init() {
    document.querySelectorAll('#cart-consent').forEach(container => {
      attachConsentValidation(container);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  // Dawn: Drawer wird dynamisch geladen → MutationObserver
  const observer = new MutationObserver(() => init());
  observer.observe(document.body, { childList: true, subtree: true });
})();
